var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-card',[_c('h1',{staticClass:"title-biaoti"},[_vm._v("实时通话监控详情")]),_c('el-row',_vm._l((_vm.channel),function(item,ind){return _c('Video',{key:ind,attrs:{"channel":item,"index":ind}})}),1),_c('el-row',[_c('el-button',{attrs:{"type":"warning"},on:{"click":_vm.Leave}},[_vm._v("返回上一级")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }